import { render, staticRenderFns } from "./degazing.vue?vue&type=template&id=61c9adf8&scoped=true&"
import script from "./degazing.vue?vue&type=script&lang=js&"
export * from "./degazing.vue?vue&type=script&lang=js&"
import style0 from "./degazing.vue?vue&type=style&index=0&id=61c9adf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c9adf8",
  null
  
)

export default component.exports